export default "__VITE_ASSET__CSh1oDiU__"